import "./App.css";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import Users from "./srceen/Staff-ID/Users";
import Login from "./srceen/login/Login";
import UsersMobile from "./srceen/UsersMobile/Users";
import Admin from "./srceen/dasboardAdmin/Admin";
import Navigation from "./components/navbar/Navigation";
import Member from "./srceen/member/Member";
import Memberlist from "./components/member-component/member-list/Memberlist";
import Usersedit from "./srceen/Edit-staff/Usersedit";
import Adduser from "./srceen/add-staff/Adduser";
import Chekin from "./components/member-component/chekin-guest/Chekin";
import Newmember from "./components/member-component/new-member/Newmember";
import Role from "./srceen/role/Role";
import Addrole from "./srceen/add-role/Addrole";
import Notfound from "./srceen/not-found/Notfound";
import Banner from "./srceen/Banner/Banner";
import Addbanner from "./srceen/add-banner/Addbanner";
import Faq from "./srceen/faq/Faq";
import Addfaq from "./srceen/add-faq/Addfaq";
import Editfaq from "./srceen/edit-faq/Editfaq";
import Editbanner from "./srceen/edit-banner/Editbanner";
import Idcard from "./srceen/id-card/Idcard";
import Sidebar from "./components/sidebar/Sidebar";
import Addusermobile from "./srceen/add-user-mobile-app/Addusermobile";
import Cafe from "./srceen/Cafe/Cafe";
import Addcafe from "./srceen/add-cafe/Addcafe";
import Spa from "./srceen/spa/Spa";
import Addspa from "./srceen/add-spa/Addspa";
import MemberModal from "./modal/memberModal/memberModal";
import Memberinfo from "./modal/memberModal/component/info/Memberinfo";
import Profiledata from "./modal/memberModal/component/profile/Profiledata";
import Logimage from "./modal/memberModal/component/image/Logimage";
import Editusermobile from "./srceen/edit-user-mobile/Edituser";
import Editcafe from "./srceen/edit-cafe/Editcafe";
import Extend from "./modal/memberModal/component/extend/Extend";
import Log from "./modal/memberModal/component/log/Log";
import axios from "axios";
import { useEffect, useState } from "react";
import Loading from "./components/loading/Loading";
import Addcheckin from "./srceen/add-checkin/Addcheckin";
import Promo from "./srceen/promo/Promo";
import Addpromo from "./srceen/add-promo/Addpromo";
import Editspa from "./srceen/edit-spa/Editspa";
import Editrole from "./srceen/edit-role/Editrole";
import Editpromo from "./srceen/edit-promo/Editpromo";
import ExpMember from "./components/member-component/exp-member/ExpMember";

function App() {

  const [userToken, setUserToken] = useState(false);
  const data = window.sessionStorage.getItem("dataLogin");
  const [loading, setLoading] = useState(true);
  const verifyLogin = async () => {
    const rest = axios.create({
      baseURL: "https://mobile.amospa.com",
      headers: { Authorization: `Bearer ${data}` },
    });
    const result = await rest.get("/jwt/token");
    if (result == undefined) {
      window.sessionStorage.clear();
    } else {
      setUserToken(result.data.data);
    }
    console.log("result", result);
    setLoading(false);
  };

  console.log("token", userToken);

  useEffect(() => {
    verifyLogin();
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/homepage/staff/id-card/:name/:id" element={<Idcard />} />
        {userToken ? (
          <Route path="/homepage" element={<Sidebar />}>
            <Route index element={<Admin />} />
            <Route path="/homepage/users-mobile" element={<UsersMobile />} />
            <Route
              path="/homepage/users-mobile/add-user"
              element={<Addusermobile />}
            />
            <Route
              path="/homepage/users-mobile/edit-user/:id"
              element={<Editusermobile />}
            />
            <Route path="/homepage/members" element={<Member />}>
              <Route index element={<Memberlist />} />
              <Route path="/homepage/members/chekin" element={<Chekin />} />
              <Route path="/homepage/members/exp" element={<ExpMember />} />
              <Route
                path="/homepage/members/new-member"
                element={<Newmember />}
              />
            </Route>
            <Route
              path="/homepage/members/add-chekin"
              element={<Addcheckin />}
            />
            <Route path="/homepage/staff" element={<Users />} />
            <Route path="/homepage/staff-edit/:id" element={<Usersedit />} />
            <Route path="/homepage/staff-add" element={<Adduser />} />
            <Route path="/homepage/setting/role" element={<Role />} />
            <Route
              path="/homepage/setting/role/addrole"
              element={<Addrole />}
            />
            <Route path="/homepage/edit-role/:id" element={<Editrole />} />
            <Route path="/homepage/setting/banner" element={<Banner />} />
            <Route
              path="/homepage/setting/banner/addbanner"
              element={<Addbanner />}
            />
            <Route
              path="/homepage/setting/banner/editbanner/:name/:id"
              element={<Editbanner />}
            />
            <Route path="/homepage/promo" element={<Promo />} />
            <Route path="/homepage/promo/add" element={<Addpromo />} />
            <Route path="/homepage/promo/:id" element={<Editpromo />} />
            <Route path="/homepage/cafe" element={<Cafe />} />
            <Route path="/homepage/cafe/add-cafe" element={<Addcafe />} />
            <Route path="/homepage/cafe/edit-cafe/:id" element={<Editcafe />} />
            <Route path="/homepage/spa" element={<Spa />} />
            <Route path="/homepage/spa/add-spa" element={<Addspa />} />
            <Route path="/homepage/spa/edit-spa/:id" element={<Editspa />} />
            <Route path="/homepage/setting/faq" element={<Faq />} />
            <Route path="/homepage/setting/faq/addfaq" element={<Addfaq />} />
            <Route
              path="/homepage/setting/faq/editfaq/:id"
              element={<Editfaq />}
            />
            {/* MODALS */}
            <Route path="/homepage/members/log/" element={<MemberModal />}>
              <Route index element={<Memberinfo />} />
              <Route
                path="/homepage/members/log/profile/"
                element={<Profiledata />}
              />
              <Route
                path="/homepage/members/log/photo/"
                element={<Logimage />}
              />
              <Route
                path="/homepage/members/log/extend/"
                element={<Extend />}
              />
              <Route path="/homepage/members/log/history/" element={<Log />} />
            </Route>
          </Route>
        ) : (
          <Route path="/" element={<Login />} />
        )}

        <Route path="*" element={loading ? <Loading /> : <Notfound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
